import { Component, HostListener } from '@angular/core';
import { NiceSdkAuthenticationService } from '../../data/CXOne/sdk-auth/nice-sdk-authentication.service';
import {
  EventType,
  SdkDigitalService,
} from '../../data/CXOne/sdk-digital/sdk-digital.service';
import { SdkAcdAgent } from '../../data/CXOne/sdk-acd/sdk-acd.service';
import { LoggerService } from '../../core/services/logger.service';
import { CXoneAuth } from '@nice-devone/auth-sdk';
import { LoginService } from '../../core/services/login.service';
import { CXoneVoiceClient } from '@nice-devone/voice-sdk';
import { CXoneClient } from '@nice-devone/agent-sdk';
import { AgentSettings } from '@nice-devone/core-sdk';
import {
  AgentSessionStatus,
  CXonePopUrl,
  UserInfo,
} from '@nice-devone/common-sdk';
import { CXoneAcdClient, CXoneVoiceContact } from '@nice-devone/acd-sdk';
import {
  DynamicsIbbaService,
  TemplateValuesChannelProvider,
} from '../../data/Dynamics/ibba/dynamics-ibba.service';
import { environment } from 'src/environments/environment';
import { CXoneDigitalContact } from '@nice-devone/digital-sdk';
import { EventHandlerService } from 'src/app/data/services/event-handler.service';
import { VoiceContactStatusAgent } from 'src/app/shared/enums/voice-contact-status-agent.enum';
import { SendReloadScreenSignalService } from 'src/app/shared/services/sendReloadScreenSignalService';
import { CxOneUtils } from 'src/app/data/CXOne/util/CxOneUtils';
import {
  ContactCenterMainService,
  TemplateValuesChannelProviders,
} from 'src/app/data/CXOne/services/main/contact-center-main.service';
import { getMediaType } from 'src/app/utils/cxone-utils';
import { TicketCreationRequestControlService } from 'src/app/shared/services/ticket-creation-request-control.service';
import { LocalStorageUtils } from 'src/app/data/CXOne/util/LocalStorageUtils';
import { JsonConverterUtils } from 'src/app/data/CXOne/util/JsonConverterUtils';

@Component({
  selector: 'app-ibba',
  standalone: true,
  imports: [],
  templateUrl: './ibba.component.html',
  styleUrl: './ibba.component.css',
})
export class IbbaComponent {
  isTemplateReady: boolean = false;
  cxoneAuth: CXoneAuth;
  private isInAutenticadora = false;
  private channelProviderVariables: TemplateValuesChannelProvider | null = null;
  private channelProviderVariablesObj: TemplateValuesChannelProviders | null =
    null;
  private isReloadedSession = false;
  private pendingPopUrls = new Map<string, CXonePopUrl>();
  private activeSessionsIds: string[] = [];
  private activeContactIds: { contactId: string; ticketId: string }[] = [];
  private sessionEnded: { contactId: string; templateAusente: string }[] = [];

  constructor(
    private niceSdkAuthService: NiceSdkAuthenticationService,
    private sdkAcdAgent: SdkAcdAgent,
    private sdkDigital: SdkDigitalService,
    private logger: LoggerService,
    private loginService: LoginService,
    private dynamics: DynamicsIbbaService,
    private eventHandler: EventHandlerService,
    private sendReloadScreenSignalService: SendReloadScreenSignalService,
    private mainService: ContactCenterMainService,
    private ticketCreationRequestControlService: TicketCreationRequestControlService,
    private localStorageUtils: LocalStorageUtils,
    private jsonConverterUtils: JsonConverterUtils,
  ) {
    this.cxoneAuth = CXoneAuth.instance;
    this.isReloadedSession = sendReloadScreenSignalService.interactionIdExist();
  }

  @HostListener('window:beforeunload', ['$event'])
  handleBeforeUnload(event: BeforeUnloadEvent): void {
    this.sendReloadScreenSignalService.sendReloadSignal();
    event.preventDefault();
    event.returnValue = '';
  }

  async ngOnInit() {
    this.logger.info('IBBA - inicializado');
    const centralId = this.localStorageUtils.safeGetItem('centralId') || 'ibba';
    const authServiceType =
      this.localStorageUtils.safeGetItem('authServiceType') || 'nice';
    const authMode =
      this.localStorageUtils.safeGetItem('display_mode') || 'popup';

    try {
      const isAuthenticated = await this.loginService.login(
        authServiceType,
        centralId,
        true,
        authMode,
      );

      if (isAuthenticated) {
        this.logger.info('IBBA - Usuario autenticado com sucesso.');
        await this.niceSdkAuthService.launchAgent();

        await this.sdkAcdAgent.initialize();
        await this.sdkDigital.initializeEvents();

        await this.dynamics.initialize(environment.cif_versao_2_ibba);

        this.channelProviderVariables =
          await this.dynamics.loadTemplateValues();

        this.logger.info(
          'IBBA - Channel Provider Variables:',
          JSON.stringify(this.channelProviderVariables, null, 2),
        );

        if (!this.channelProviderVariables) {
          this.logger.error(
            'IBBA - Erro ao carregar environment do CIFramework',
            JSON.stringify(this.channelProviderVariables, null, 2),
          );
        }

        /** ##### INCIO EVENTO DIGITAL IBBA ##### **/
        this.sdkDigital.onDigitalContactEvent$.subscribe(
          async (digitalContact: CXoneDigitalContact) => {
            this.logger.info(
              `IBBA - NICE Event Details: ${JSON.stringify(digitalContact.eventDetails)}`,
            );

            if (digitalContact.eventDetails.eventType === 'CaseInboxAssigned') {
              this.logger.info(
                'IBBA - Evento digital recebido: ',
                JSON.stringify(digitalContact.case),
              );

              //Obtendo o Object Channel Providers Variables
              await this.getTemplateValues();

              this.processDigitalCreateEvent(digitalContact);
            }

            if (
              digitalContact.eventDetails.eventType === 'CaseInboxUnassigned'
            ) {
              this.processDigitalEndedEvent(digitalContact);
            }
          },
        );

        this.sdkAcdAgent.instance.screenPop.screenPopSubscribe(
          true,
          true,
          true,
          true,
          true,
          true,
        );

        this.sdkAcdAgent.instance.screenPop.popUrlSubject.subscribe(
          async (popUrlData) => {
            this.DigitalAttachDataEventHandler(popUrlData);
          },
        );
        /** ##### FIM EVENTO DIGITAL IBBA ##### **/

        this.logger.info(
          'DYNAMICS - terminando de adicionar Handler de session switch',
        );

        var input = {
          templateName: this.channelProviderVariables?.templateSessaoPadrao,
          templateParameters: {},
          context: {
            sessaobetta: true,
          },
        };

        // abre uma aba com a listagem de tickets associados a um usuário
        await this.dynamics.cifCreateSession(input, null, '');

        /** ##### INCIO EVENTO VOICE IBBA ##### **/
        this.sdkAcdAgent.voiceContactUpdate$.subscribe(
          async (voiceContact: CXoneVoiceContact) => {
            const status = voiceContact.status || '';
            const contactId = voiceContact.contactID || '';
            const contatoEvento = { id: contactId, status: status };
            const skillName = voiceContact.skillName || '';
            const contact = voiceContact.isInbound ? 'INBOUND' : 'OUTBOUND';
            const callType = voiceContact.callType || '';
            const screenPopUrl = voiceContact.screenPopUrl || '';
            let eventoProcessado = this.eventHandler.isProcessed(contatoEvento);
            const logStringAgent = `Contato: ${contact} | Status: ${status} | ContactID: ${contactId} | skillName: ${skillName} | callType: ${callType} | eventoProcessado: ${eventoProcessado} `;

            this.logger.info(
              `IBBA (ACD - Evento Geral - ${logStringAgent}): `,
              voiceContact,
            );

            if (
              status === VoiceContactStatusAgent.ACTIVE &&
              !eventoProcessado
            ) {
              this.logger.info(
                `IBBA (ACD - ${logStringAgent} | screenPopUrl: ${screenPopUrl}) | Iniciando atendimento.`,
              );

              this.eventHandler.add(contatoEvento);

              //Obter o object channel provider variables
              await this.getTemplateValues();

              await this.processVoiceContactEvent(
                voiceContact,
                logStringAgent,
                contact,
              );
            }

            if (status === VoiceContactStatusAgent.DISCONNECTED) {
              this.eventHandler.remove(contatoEvento);
              const sessionId = this.localStorageUtils.safeGetItem(
                voiceContact.contactID,
              );

              if (!sessionId) {
                this.logger.info(
                  `IBBA (ACD - ${logStringAgent}) | sessionId não encontrado no localStorage, não é possível encerrar: ${voiceContact.contactID}`,
                );
                return;
              }

              var context = {
                itau_cliente_on: false,
                itau_sessao_ativa: false,
              };

              this.logger.info(
                `IBBA (ACD - ${logStringAgent}) - encerrando sessão: ${sessionId}`,
              );

              if (this.isReloadedSession === true) {
                this.sendReloadScreenSignalService.removeInteractionIdInLocalStorage();
                this.isReloadedSession = false;
              } else {
                this.sendReloadScreenSignalService.removeInteractionIdInLocalStorage();
              }

              this.logger.info(
                `IBBA (ACD - ${logStringAgent}) - Contato desconectado ou transferido`,
              );

              this.localStorageUtils.safeRemoveItem(voiceContact.contactID);
              this.localStorageUtils.safeRemoveItem(sessionId);
            }
          },
        );
        /** ##### FIM EVENTO VOICE IBBA ##### **/

        CXoneAcdClient.instance.session.agentLegEvent.subscribe((data: any) => {
          CXoneVoiceClient.instance.handleAgentLegEvent(data);
          if (data.status === 'Dialing') {
            // CXoneVoiceClient.instance.triggerAutoAccept(data.agentLegId);
            CXoneVoiceClient.instance.connectAgentLeg(data.agentLegId);
          }
        });

        CXoneAcdClient.instance.session.onAgentSessionChange.subscribe(
          async (agentSessionChange) => {
            switch (agentSessionChange.status) {
              case AgentSessionStatus.JOIN_SESSION_SUCCESS:
              case AgentSessionStatus.SESSION_START: {
                this.logger.info('Agent session started successfully.....');
                // setStartSessionButton(true);
                await this.initWebRTC();
                break;
              }
              case AgentSessionStatus.SESSION_END: {
                this.logger.info('Agent session ended successfully.....');
                break;
              }
              case AgentSessionStatus.JOIN_SESSION_FAILURE:
                this.logger.info('Agent session join failed.....');
                break;
            }
          },
        );
      } else {
        this.logger.info('IBBA - Usuario nao autenticado');
      }
    } catch (error) {
      this.logger.error('IBBA - Erro ao autenticar usuario: ', error);
    }
  }

  /** ##### INICIO MÉTODOS DE PROCESSAMENTO DO DIGITAL IBBA ##### **/
  private async processDigitalCreateEvent(digitalContact: CXoneDigitalContact) {
    let attachdata: any = {};
    let contactId = '';
    let popUrl: any = '';

    try {
      if (!digitalContact) {
        this.logger.error(
          'IBBA - Evento principal digitalContact não recebido',
        );
        throw new Error('DIGITAL_CONTACT_NULL');
      }

      //Recebendo o valor do caseId
      contactId = digitalContact.caseId;
      this.logger.info(
        'IBBA - ContactId do evento digital recebido: ',
        contactId,
      );

      const ujson = await this.mainService.generatePopUrlFronDigitalContact(
        digitalContact,
        'IBBA',
      );

      if (!ujson) {
        this.logger.warn(
          'IBBA - Dados não obtidos da extração do digitalEvent.',
        );
        this.logger.info('IBBA - Obtendo dados do evento de screenPop Url.');

        popUrl = await this.handleFallbackPopUrl(digitalContact.caseId);

        attachdata = this.deserializeScreenPopUrl(popUrl);
      } else {
        popUrl = ujson.popUrl;

        const popUrlData = JSON.stringify(popUrl);

        // try {
        //   attachdata = JSON.parse(popUrlData);
        // } catch {
        //   attachdata = {};
        // }

        attachdata = this.jsonConverterUtils.JsonParsed(popUrlData);
      }

      this.logger.info(
        `IBBA - attachdata deserializado: ${JSON.stringify(attachdata)}`,
      );

      const datacb: any = {};
      datacb['itau_name'] =
        this.channelProviderVariablesObj?.itau_name ??
        attachdata.itau_u_nomeprojeto;
      datacb['itau_mst_attachdata'] = JSON.stringify(attachdata.u_json);
      datacb['itau_u_lk_projeto@odata.bind'] =
        this.channelProviderVariablesObj?.itau_u_lk ?? attachdata.itau_u_lk;
      datacb['itau_u_nomeprojeto'] =
        this.channelProviderVariablesObj?.itau_u_nomeprojeto ??
        attachdata.itau_u_nomeprojeto;
      datacb['itau_st_id_conexao'] = contactId;
      datacb['jw7_st_plugin'] =
        this.channelProviderVariablesObj?.itau_u_nomeprojeto ??
        attachdata.itau_u_nomeprojeto;

      this.logger.info(
        'IBBA - Dados do ticket a serem criados: ',
        JSON.stringify(datacb),
      );

      const result = await this.dynamics.cifCreateTicket(
        datacb,
        attachdata.u_json,
        digitalContact.contactID!,
        getMediaType(digitalContact),
      );

      if (!result || !result.id_interacao || !result.id_ticket) {
        this.logger.error(
          `IBBA - Erro ao criar ticket: ${JSON.stringify(result)}`,
        );
        return;
      }

      let input_atendimento = {
        templateName: this.channelProviderVariables?.templateCreateSession,
        templateParameters: {
          id_interacao: result.id_interacao,
          id_ticket: result.id_ticket,
        },
      };

      this.logger.info(
        `IBBA - Criando sessão: ${JSON.stringify(input_atendimento)}`,
      );

      const sessionId = await this.dynamics.cifCreateSession(
        input_atendimento,
        getMediaType(digitalContact),
        contactId,
      );
      this.localStorageUtils.safeSetItem(contactId, sessionId);
      this.localStorageUtils.safeSetItem(sessionId, contactId);

      this.sendReloadScreenSignalService.setInteractionIdInLocalStorage(
        contactId,
      );

      this.logger.info(
        `IBBA - função de criação de ticket executada com sucesso: ${JSON.stringify(input_atendimento.templateParameters)}`,
      );
    } catch (error) {
      this.eventHandler.remove({ id: contactId, status: '' });
      this.logger.error(`IBBA - Erro ao processar contato de voz: ${error}`);
    }
  }

  private async processDigitalEndedEvent(digitalEvent: CXoneDigitalContact) {
    const sessionRelationship = this.localStorageUtils.safeGetItem(
      `sessionRelationship-${digitalEvent.caseId}`,
    );

    this.logger.info(
      'IBBA - Evento de encerramento recebebido: ',
      JSON.stringify(sessionRelationship),
    );

    this.localStorageUtils.safeRemoveItem(digitalEvent.caseId);
    this.ticketCreationRequestControlService.removeTicketRequest(
      digitalEvent.caseId,
    );
  }

  private async DigitalAttachDataEventHandler(popUrl: CXonePopUrl) {
    this.logger.info('PopUrl recebido: ', popUrl);
    this.logger.info('tabTitle: ', popUrl.tabTitle?.toUpperCase());
    this.logger.info('contact ID: ', popUrl.contactId);

    if (popUrl.tabTitle?.toUpperCase() === 'ATTACHESDYNAMICS') {
      this.pendingPopUrls.set(popUrl.contactId, popUrl);
      this.logger.info(
        'Attachdata armazenado para contato digital: ',
        popUrl.contactId,
      );
    }

    if (popUrl.tabTitle?.toUpperCase() === 'FOCUS') {
      const dynamicsSessionData = this.localStorageUtils.safeGetItem(
        `sessionRelationship-${popUrl.contactId}`,
      );

      if (dynamicsSessionData === null) return;

      // const sessionRelationship: {
      //   dynamicsSessionId: string;
      //   dynamicsinteractionId: string;
      // } = JSON.parse(dynamicsSessionData);

      //localstorageHelper

      let parsedData: {
        dynamicsSessionId: string;
        dynamicsinteractionId: string;
      } = {
        dynamicsSessionId: '',
        dynamicsinteractionId: '',
      };

      // try {
      //   parsedData = JSON.parse(dynamicsSessionData);
      // } catch {
      //   parsedData = {
      //     dynamicsSessionId: '',
      //     dynamicsinteractionId: '',
      //   };
      // }

      parsedData = this.jsonConverterUtils.JsonParsed(dynamicsSessionData);

      const sessionRelationship = parsedData;

      this.logger.info(
        'Solicitação de foco recebida: ',
        JSON.stringify(dynamicsSessionData),
      );

      this.logger.info(
        'Chamando raise event alterarSessao com os valores: ',
        sessionRelationship,
      );

      await (window as any).Microsoft.CIFramework.raiseEvent(
        'ControleFocarSessao',
        {
          sessionId: sessionRelationship.dynamicsSessionId,
          correlationId: sessionRelationship.dynamicsinteractionId,
        },
      );
    }
  }
  /** ##### FIM MÉTODOS DE PROCESSAMENTO DO DIGITAL IBBA ##### **/

  /** ##### INICIO MÉTODOS DE PROCESSAMENTO DO VOICE IBBA ##### **/
  private async processVoiceContactEvent(
    voiceContact: CXoneVoiceContact,
    logStringAgent: string,
    contact: string,
  ): Promise<void> {
    let id_interacao: string | null = null;
    let id_ticket: string | null = null;

    try {
      if (typeof (window as any).Microsoft !== 'undefined') {
        const attachdata = this.deserializeScreenPopUrl(
          voiceContact.screenPopUrl,
        );

        this.logger.info(
          `IBBA (ACD - ${logStringAgent}) - attachdata deserializado: ${JSON.stringify(attachdata)}`,
        );

        const datacb: any = {};
        datacb['itau_name'] =
          this.channelProviderVariablesObj?.itau_name ??
          attachdata.itau_u_nomeprojeto;
        datacb['itau_mst_attachdata'] = JSON.stringify(attachdata.u_json);
        datacb['itau_u_lk_projeto@odata.bind'] =
          this.channelProviderVariablesObj?.itau_u_lk ?? attachdata.itau_u_lk;
        datacb['itau_u_nomeprojeto'] =
          this.channelProviderVariablesObj?.itau_u_nomeprojeto ??
          attachdata.itau_u_nomeprojeto;
        datacb['itau_st_id_conexao'] = voiceContact.contactID;
        datacb['jw7_st_plugin'] =
          this.channelProviderVariablesObj?.itau_u_nomeprojeto ??
          attachdata.itau_u_nomeprojeto;

        this.logger.info(
          `IBBA (ACD - ${logStringAgent}) - Dados do ticket a serem criados: ${JSON.stringify(datacb)}`,
        );

        if (attachdata.u_json && voiceContact.callType !== 'Consult') {
          const interaction = await this.dynamics.cifUpdateTicket(
            attachdata.u_json,
            voiceContact.contactID,
            'voice',
          );

          if (interaction.id_ticket === null) {
            const result = await this.dynamics.cifCreateTicket(
              datacb,
              attachdata.u_json,
              voiceContact.contactID!,
              'voice',
            );

            if (!result?.id_interacao || !result?.id_ticket) {
              this.logger.error(
                `IBBA (ACD - ${logStringAgent}) - Erro ao criar ticket: ${JSON.stringify(result)}`,
              );
              return;
            }

            id_interacao = result.id_interacao;
            id_ticket = result.id_ticket;
          } else {
            id_interacao = interaction.id_interacao;
            id_ticket = interaction.id_ticket;
          }

          await this.canCreateSession(
            id_interacao,
            id_ticket,
            logStringAgent,
            voiceContact.contactID,
          );
        } else {
          if (
            !voiceContact.isInbound &&
            voiceContact.callType === 'Regular' &&
            voiceContact.disconnectCode !== 'TransferComplete'
          ) {
            await this.canCreateSession(
              id_interacao,
              id_ticket,
              logStringAgent,
              voiceContact.contactID,
            );
          }
        }
      } else {
        this.logger.warn(
          'Função microsoft.Microsoft.Cif ainda não está disponível.',
        );
      }
    } catch (error) {
      this.eventHandler.remove({ id: voiceContact.contactID, status: '' });
      this.logger.error(
        `IBBA (ACD - ${logStringAgent}) - Erro ao processar contato de voz: ${error}`,
      );
    }
  }
  /** ##### FIM MÉTODOS DE PROCESSAMENTO DO VOICE IBBA ##### **/

  //Aguardar para rechamar
  async aguardarRechamada(ms: number) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async getWebRtcServiceUrls() {
    const agentSettings =
      (await CXoneClient.instance.agentSetting.getAgentSettings()) as AgentSettings;
    const getUserInfo =
      (await CXoneClient.instance.cxoneUser.getUserDetails()) as UserInfo;
    if (!agentSettings && getUserInfo.icAgentId) {
      return;
    }

    return {
      agentId: getUserInfo.icAgentId,
      agentSettings: agentSettings,
      userInfo: getUserInfo,
    };
  }

  deserializeScreenPopUrl(screenPopUrl: string) {
    const objeto: any = {};

    // prettier-ignore
    screenPopUrl = screenPopUrl.replaceAll("'", "\"");

    const pares = screenPopUrl.split('|');

    pares.forEach((par) => {
      const idx = par.indexOf(':');
      if (idx > -1) {
        const chave = par.substring(0, idx);
        const valor = par.substring(idx + 1);
        if (chave) {
          try {
            objeto[chave.toLowerCase()] = JSON.parse(valor);
          } catch (e) {
            objeto[chave.toLowerCase()] = valor;
          }
        }
      }
    });

    return objeto;
  }

  private async canCreateSession(
    id_interacao: string | null,
    id_ticket: string | null,
    logStringAgent: string,
    contactId: string,
  ) {
    try {
      let input_atendimento = {
        templateName: this.channelProviderVariables?.templateCreateSession,
        templateParameters: {
          id_interacao: id_interacao,
          id_ticket: id_ticket,
        },
      };

      this.logger.info(
        `IBBA (ACD - ${logStringAgent}) - Criando sessão: ${JSON.stringify(input_atendimento)}`,
      );

      // abre uma aba com o ticket que foi aberto e salva o sessionId no localStorage
      const sessionId = await this.dynamics.cifCreateSession(
        input_atendimento,
        'voice',
        contactId,
      );
      this.localStorageUtils.safeSetItem(contactId, sessionId);
      this.localStorageUtils.safeSetItem(sessionId, contactId);

      this.sendReloadScreenSignalService.setInteractionIdInLocalStorage(
        contactId,
      );

      this.logger.info(
        `IBBA (ACD - ${logStringAgent}) - função de criação de ticket executada com sucesso: ${JSON.stringify(input_atendimento.templateParameters)}`,
      );
    } catch (error) {
      this.logger.error(
        `IBBA (ACD - ${logStringAgent}) - Erro ao criar sessão: ${error}`,
      );
      throw new Error(
        `IBBA (ACD - ${logStringAgent}) - Erro ao criar sessão: ${error}`,
      );
    }
  }

  private async getTemplateValues() {
    await this.mainService
      .loadTemplateValues('IBBA')
      .then((obj) => {
        this.channelProviderVariablesObj = obj;

        if (!obj) {
          this.logger.error(
            'IBBA - Channel provider object nulo, ',
            JSON.stringify(obj, null, 2),
          );
        }

        this.logger.info(
          'IBBA - Channel provider variables object: ',
          JSON.stringify(obj, null, 2),
        );
      })
      .catch((error) => {
        this.logger.error(
          'IBBA - Erro ao carregar o object channel provider variables, ',
          error,
        );
      });
  }

  private async handleFallbackPopUrl(caseId: string) {
    let popUrl = '';

    this.logger.info('IBBA - Iniciando busca pelo evento de popUrl');

    for (let tentativa = 1; tentativa <= 10; tentativa++) {
      this.logger.info(`IBBA - Tentativa ${tentativa} de 10.`);

      popUrl = this.pendingPopUrls.get(caseId)?.url ?? '';

      if (popUrl) {
        this.logger.info('IBBA - PopUrl encontrado:', caseId);
        break;
      }

      this.logger.warn('IBBA - PopUrl não encontrado:', caseId);

      await CxOneUtils.Delay(1000);
    }

    return popUrl;
  }

  // private safeGetItem(key: string): string | null {
  //   try {
  //     return localStorage.getItem(key);
  //   } catch {
  //     return null;
  //   }
  // }

  // private safeSetItem(key: string, value: string): void {
  //   try {
  //     localStorage.setItem(key, value);
  //   } catch {
  //     // opcional: log
  //   }
  // }

  // private safeRemoveItem(key: string): void {
  //   try {
  //     localStorage.removeItem(key);
  //   } catch {
  //     // opcional: log
  //   }
  // }

  async initWebRTC() {
    try {
      const agentSettings = (await this.getWebRtcServiceUrls()) as {
        agentId: string;
        agentSettings: AgentSettings;
        userInfo: UserInfo;
      };

      const app = 'Nice CXone SDK Consumer';
      const appName = `${(app || 'cxa').toUpperCase()}: ${agentSettings?.agentSettings.cxaClientVersion}`;
      CXoneVoiceClient.instance.connectServer(
        agentSettings?.agentId,
        agentSettings?.agentSettings,
        new Audio('<audio ref={audio_tag} id="audio" controls autoPlay/>'),
        appName,
      );
      this.logger.info('Connected to WebRTC');
    } catch (e) {
      this.logger.error(`Error initializing WebRTC: ${e}`);
    }
  }
}
